import { createApiCallAction } from 'reacticoon/action'

export const getDiscordLoginUrl = createApiCallAction(
  'App::DiscordAuthModule::getDiscordLoginUrl',
  () => ({
    type: 'POST',
    endpoint: '/commands/AUTH_DISCORD_LOGIN',
    body: {
      command: 'AUTH_DISCORD_LOGIN',
    },
  })
)

export const handleDiscordCallback = createApiCallAction(
  'App::DiscordAuthModule::handleDiscordCallback',
  (code, state) => ({
    type: 'POST',
    endpoint: '/commands/AUTH_DISCORD_CALLBACK',
    body: {
      command: 'AUTH_DISCORD_CALLBACK',
      code,
      state,
    },
  })
)
